export default "__VITE_PUBLIC_ASSET__6d4c89fb__"